import { getUniqueItem } from 'helpers/utils'
import ActivityTypes from 'store/actionTypes/activity'
import UserTypes from 'store/actionTypes/user'

const initialData = {
  list: [],
  pagination: {}
}

const activity = (state = initialData, action = {}) => {
  const { payload, meta } = action
  switch (action.type) {
    case ActivityTypes.GET_ACTIVITIES_SUCCESS:
      if (meta?.params?.data?.offset === 0) {
        return {
          ...state,
          list: payload?.items || [],
          pagination: payload?.meta || {}
        }
      }
      return {
        ...state,
        list: getUniqueItem([...(state.list || []), ...(payload?.items || [])]),
        pagination: payload?.meta || {}
      }
    case UserTypes.LOGOUT_SUCCESS:
      return initialData
    default:
      return state
  }
}

export default activity
